import { ChangeDetectionStrategy, Component, ElementRef, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicFormModule } from 'core/dynamic-form';
import { FixedScrollDirective } from 'core/shared-components';
import { DynamicFormDialogPayload, DynamicFormDialogService } from './dynamic-form-dialog.service';


@Component({
  selector: 'ss-dynamic-form-dialog',
  templateUrl: './dynamic-form-dialog.component.html',
  styleUrls: ['./dynamic-form-dialog.component.css'],
  standalone: true,
  imports: [
    DynamicFormModule,
    MatIconModule,
    MatButtonModule,
    TranslateModule,
    MatCardModule,
    MatDialogModule,
    FixedScrollDirective
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DynamicFormDialogComponent implements OnInit {

  @ViewChild('cardHeader', { read: ElementRef })
  private _header: ElementRef<HTMLElement>
  get header() {
    return this._header?.nativeElement
  }

  get baseElement() {
    return this._elementRef.nativeElement
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: DynamicFormDialogPayload,
    private readonly _dynamicFormDialogService: DynamicFormDialogService,
    private readonly _elementRef: ElementRef<HTMLElement>
  ) { }

  ngOnInit(): void {

  }

  cancel() {
    this._dynamicFormDialogService._dialogRef.close();
  }

  submit(formData: any) {

    this._dynamicFormDialogService._dialogRef.close(formData);
  }

}
